export const generatePaginatedDataQuery = (page: number, pageSize = 30): string => {
    const pagination = {
        page,
        itemsPerPage: pageSize,
    };

    return Object.entries(pagination)
        .map(entry => entry.join('='))
        .join('&');
};
